import sum from './sum';
export default function average(iterable, selector) {
    const array = [...iterable];
    return sum(array, selector) / array.length;
}
